exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-left-status[data-v-d4c3ed98] {\n  margin-right: 5px;\n}\n.content-line[data-v-d4c3ed98] {\n  padding: 12px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.content-line-1[data-v-d4c3ed98] {\n  padding: 6px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.color-1[data-v-d4c3ed98] {\n  background: #6aa5e3;\n}\n.color-2[data-v-d4c3ed98] {\n  background: orange;\n}\n.color-3[data-v-d4c3ed98] {\n  background: #ef5b5b;\n}\n.color-4[data-v-d4c3ed98] {\n  background: #191717e8;\n}\n", ""]);

// exports
